import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { ANONYMOUS_ROUTES, LOGGED_IN_ROUTES } from "../Constants";
import { GeneralState } from "../Redux";
import MulticoteAgriSolutionPage from "./MulticoteAgriSolution";
import MulticoteSolutionPage from "./MulticoteSolution";
import SavedItemsPage from "./SavedItems";
import AboutPage from "./About";
import ContactUsPage from "./ContactUs";
import UserAreaPage from "./UserAreaPage";
import { FmLayout } from "../Components";
import { shareableItemTypes } from "../Utils/Enums";
import { SavedItemsState } from "../Redux/States";

const LoggedInUserRouter = () => {
    const agriIsMainInterest = useSelector(GeneralState.Selectors.selectAgriIsMainInterestOfUser);

    const isUserNeedToNavigateToSharableSavedItem = useSelector(GeneralState.Selectors.selectIsUserNeedToViewSharableItem);
    const typeOfSharableSavedItem = useSelector(GeneralState.Selectors.selectTypeOfSharableItem);

    const isUserSignedIn = useSelector(GeneralState.Selectors.selectIsUserLoggedIn);

    const userWantsToBeRemembered = useSelector(GeneralState.Selectors.selectUserWantsToBeRemembered);
    const sharedItemId = useSelector(GeneralState.Selectors.selectSharedItemId);
    const defaultPath = agriIsMainInterest ? LOGGED_IN_ROUTES.AGRI_SOLUTION : LOGGED_IN_ROUTES.SOLUTION;
    return (
        <BrowserRouter basename='/multi-match'>
            <Switch>
                <FmLayout>
                    <Redirect
                        from='/'
                        to={
                            typeOfSharableSavedItem == shareableItemTypes.empty
                                ? defaultPath
                                : typeOfSharableSavedItem == shareableItemTypes.multicote
                                ? LOGGED_IN_ROUTES.SOLUTION_SECOND_STEP
                                : LOGGED_IN_ROUTES.AGRI_SOLUTION_RELEASE_CHART
                        }
                    />

                    {/* {typeOfSharableSavedItem ==
            shareableItemTypes.agri_multicote_customize ||
            (typeOfSharableSavedItem ==
              shareableItemTypes.agri_multicote_ready_made && (
              <Redirect
                from="/"
                to={LOGGED_IN_ROUTES.AGRI_SOLUTION_RELEASE_CHART}
              />
            ))} */}

                    <Route path={LOGGED_IN_ROUTES.AGRI_SOLUTION} component={MulticoteAgriSolutionPage} />
                    <Route path={LOGGED_IN_ROUTES.SOLUTION} component={MulticoteSolutionPage} />
                    <Route path={LOGGED_IN_ROUTES.SAVED_ITEMS} component={SavedItemsPage} />
                    <Route path={LOGGED_IN_ROUTES.ABOUT} component={AboutPage} />
                    <Route path={LOGGED_IN_ROUTES.CONTACT_US} component={ContactUsPage} />
                    <Route path={LOGGED_IN_ROUTES.USER_AREA} component={UserAreaPage} />
                </FmLayout>
            </Switch>
        </BrowserRouter>
    );
};

export default LoggedInUserRouter;
